// @ts-nocheck

function boldBeforePipe(root = document) {
  const labels = root.querySelectorAll('.tpo_option_label');

  labels.forEach((el) => {
    if (el.dataset.boldified === '1') return;

    const text = el.textContent.trim();
    if (!text.includes('|')) return;

    const parts = text.split('|');
    const left = parts.shift().trim();
    const right = parts.join('|').trim();

    el.innerHTML = `<strong>${left}</strong>${right ? ' | ' + right : ''}`;
    el.dataset.boldified = '1';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  boldBeforePipe();

  document.addEventListener('change', (e) => {
    if (e.target.matches('.tpo_image-swatches-input, .tpo_color-swatches-input')) {
      const container = e.target.closest('.tpo_swatches-label_position') || document;
      boldBeforePipe(container);
    }
  });

  const observer = new MutationObserver(() => boldBeforePipe());
  observer.observe(document.body, { childList: true, subtree: true });
});
